/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ForgotPasswordInput = {
    email: string;
};
export type ForgotPasswordMutationVariables = {
    input: ForgotPasswordInput;
};
export type ForgotPasswordMutationResponse = {
    readonly forgotPassword: {
        readonly success: boolean;
    };
};
export type ForgotPasswordMutation = {
    readonly response: ForgotPasswordMutationResponse;
    readonly variables: ForgotPasswordMutationVariables;
};



/*
mutation ForgotPasswordMutation(
  $input: ForgotPasswordInput!
) {
  forgotPassword(input: $input) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ForgotPasswordPayload",
    "kind": "LinkedField",
    "name": "forgotPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ForgotPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForgotPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b19ad8d883e742eb8398671329753ac2",
    "id": null,
    "metadata": {},
    "name": "ForgotPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation ForgotPasswordMutation(\n  $input: ForgotPasswordInput!\n) {\n  forgotPassword(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c6218d4d521832099aae6cb28b8e6234';
export default node;
